import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Form, Col, Button } from 'react-bootstrap'

export default function ContactSection() {
    return (
        <div className='contact-section' id='contact-section' style={{background:'#DCDCDC'}}>
            <div className='contact-title-section d-flex align-items-center justify-content-center'>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <h3 style={{ fontWeight: '700', fontSize: '2em' }}>Contact</h3>
                </AnimationOnScroll>
            </div>
            <div className='row mx-0'>
                <Col md={6}></Col>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='col col-md-6 d-flex flex-column align-items-end contact-form'>
                    <div className='d-flex  w-100'>
                        <Form.Control placeholder='Name' className='me-4' />
                        <Form.Control placeholder='Email' />
                    </div>
                    <div className='d-flex mt-4 w-100'>
                        <Form.Control placeholder='Phone' className='me-4' />
                        <Form.Control placeholder='Company(optional)' />
                    </div>
                    <Form.Control as='textarea' rows={4} placeholder='Your message' className='mt-4' />
                    <div className='d-flex mt-4'>
                        <Button style={{ background: '#FCCD37', color: '#000', borderRadius: '0px', borderColor: '#FCCD37', fontWeight: '700' }}>
                            SEND A MESSAGE
                        </Button>
                    </div>
                </AnimationOnScroll>
            </div>
        </div>
    )
}
